const ENVIRONMENT = import.meta.env;
ENVIRONMENT.VITE_LARGE_USER_SOURCE_TOKEN_THRESHOLD = Number(ENVIRONMENT.VITE_LARGE_USER_SOURCE_TOKEN_THRESHOLD);
ENVIRONMENT.VITE_CONTEXT_TOKEN_LIMIT = Number(ENVIRONMENT.VITE_CONTEXT_TOKEN_LIMIT);

export { ENVIRONMENT };
